import DialogProvider from "./DialogContext";
import SnackbarProvider from "./SnackbarContext";

const ToolsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <SnackbarProvider>
      <DialogProvider>{children}</DialogProvider>
    </SnackbarProvider>
  );
};

export default ToolsProvider;
